var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sectionEditGroup"},[_c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"edit"},[_c('WorkflowList',{staticClass:"workflow-list",attrs:{"searchFilters":{group_identifier: _vm.group.identifier},"fields":_vm.fields,"busy":_vm.busy}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-content"},[_c('h2',[_vm._v(" Workflows ")])])
}]

export { render, staticRenderFns }